import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, input, output } from '@angular/core';
import { Location } from '@era/locations-sdk';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import {
  ContextMenuComponent,
  PanelComponent,
  PanelHeaderComponent,
  SkSpinner3Component,
  TitleComponent,
} from '@rocksoft/cdk';
import { AddLocationTemplateContext, LocationTemplateContext } from '../../models/template-contexts.model';

@Component({
  selector: 'era-locations-list-ui',
  templateUrl: './locations-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PanelComponent,
    PanelHeaderComponent,
    TitleComponent,
    ContextMenuComponent,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    SkSpinner3Component,
    NgTemplateOutlet,
  ],
})
export class LocationsListComponent {
  public readonly locations = input<Location[]>([]);
  public readonly processing = input(false);
  public readonly isVisible = input(false);

  public readonly locationsTemplate = input<TemplateRef<LocationTemplateContext> | undefined>(undefined);
  public readonly addLocationTemplate = input<TemplateRef<AddLocationTemplateContext> | undefined>(undefined);

  public editEnabled = false;
  public readonly brandId = input<string | undefined>(undefined);
  public readonly exportDevicesEvent = output();
  public readonly openSettingsEvent = output();

  public toggleEdit() {
    this.editEnabled = !this.editEnabled;
  }

  public exportDevices() {
    this.exportDevicesEvent.emit();
  }

  public openSettings() {
    this.openSettingsEvent.emit();
  }
}
